const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24,1c0-0.6-0.4-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l0,0L20.6,2H13c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0 l-12,12c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.2-0.1,0.5,0,0.8c0,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0,0l8,8c0,0,0,0,0,0 c0.1,0.1,0.2,0.2,0.3,0.2C8.7,24,8.8,24,9,24c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.2-0.1,0.3-0.2l4-4c0,0,0,0,0,0 l8-8c0.1-0.1,0.2-0.2,0.2-0.3C22,11.3,22,11.1,22,11V3.4l1.7-1.7C23.9,1.5,24,1.3,24,1z M9,21.6L2.4,15L5,12.4l6.6,6.6L9,21.6z  M13,17.6L6.4,11l7-7h5.2l-2.3,2.3l0,0C16.1,6.5,16,6.7,16,7c0,0.6,0.4,1,1,1c0.3,0,0.5-0.1,0.7-0.3L20,5.4v5.2L13,17.6z"
});

const SvgTag = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.ca08c922.svg";
export { ForwardRef as ReactComponent };